import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PublicSablonyFiltrDto } from '@generated/be';
import { getBasicSinglePageQueryParamList } from '@reza-ais-fe/reza-ais-fe-utils';
import { PageHeaderComponent } from '@shared/ui/components';
import { Logger, LoggerService, UIService } from '@shared/utils';
import { TableLazyLoadEvent } from 'primeng/table';
import { Router } from '@angular/router';
import { SeznamSablonOverviewFilterComponent } from './seznam-sablon-overview-filter/seznam-sablon-overview-filter.component';
import { SeznamSablonStateService } from '../../services/seznam-sablon-state.service';
import { SeznamSablonFilterFormService } from '../../services/seznam-sablon-filter-form.service';
import { Cy_Katalog } from '@features/cypress';
@Component({
  selector: 'reza-seznam-sablon-main',
  standalone: true,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  imports: [CommonModule, PageHeaderComponent, SeznamSablonOverviewFilterComponent],
  providers: [SeznamSablonFilterFormService],
})
export class SeznamSablonMainPageComponent {
  public readonly seznamSablonOverviewState = inject(SeznamSablonStateService);
  private readonly uiService = inject(UIService);
  readonly router = inject(Router);
  readonly loggerService = inject(LoggerService);
  readonly Cy_Katalog = Cy_Katalog;

  private logger: Logger = this.loggerService.createLogger('SeznamSablonMainPageComponent');

  onLazyLoad(event: TableLazyLoadEvent) {
    const sorting: string[] = [];
    const basicSinglePageQueryParams = getBasicSinglePageQueryParamList(event, sorting);
    this.seznamSablonOverviewState.findWithParcialFilter({
      pageAndSortList: basicSinglePageQueryParams,
    });
  }

  handleSubmitFilter(filter: PublicSablonyFiltrDto) {
    this.logger.debug('handleSubmitFilter', filter);
    this.seznamSablonOverviewState.findWithNewFilter(filter);
  }

  handleClearFilter(filter: PublicSablonyFiltrDto) {
    this.logger.debug('handleClearFilter', filter);
    this.seznamSablonOverviewState.findWithClearFilter(filter);
  }
}
